import axios from '@/utils/axios';

// Types

export enum ModePassage {
	ALL = 0,
	PASSAGES = 1,
	SHOP = 2,
	RESOURCES = 3
}

// API

export default {
	async getAll(modePassage: ModePassage = ModePassage.ALL): Promise<any[]> {
		return (await axios().get(`/services/?modePassage=${modePassage}`)).data;
    },
    async GetAllReservable(modePassage: ModePassage = ModePassage.ALL): Promise<any[]> {
        return (await axios().get(`/services/Reservable/?modePassage=${modePassage}`)).data;
	},
};
